import styled, { css } from 'styled-components';
import Text from '@/styles/Themes/Text';
import Screen from '@/styles/Themes/Screen';
import { cssVars } from '@/styles/Themes/cssVars';
import { FlexPresets } from '@/styles/Themes/Presets';
import { borders, radius } from '@/styles/Themes/Metrics';
import { Button } from '@/common/ui';
import { DropdownArrow } from '@/shared/images/icons/DropdownArrow';
import { Transition } from '@/styles/Themes/KeyFrames';

export const PromoWrapper = styled.div`
    width: 100%;
    text-align: left;
    padding: 0 24px;
    margin-bottom: 20px;
    max-width: 680px;

    ${Screen.ipad} {
        padding: 0 42px;
    }

    ${Screen.desktop} {
        padding: 0 56px;
    }
`;

export const PromoTitle = styled.div`
    color: ${cssVars.fg_gray1_white};
    ${Text.Full.large.medium};
    cursor: pointer;
    display: flex;
    align-items: center;
`;

export const Animation = styled.div<{ isOpen: boolean }>`
    ${({ isOpen }) =>
        isOpen
            ? css`
                  @keyframes down {
                      from {
                          max-height: 0;
                          overflow: hidden;
                      }

                      to {
                          max-height: 100vh;
                          overflow: auto;
                      }
                  }

                  animation-duration: 2s;
                  animation-name: down;
                  animation-timing-function: ease-out;
              `
            : css`
                  height: 0;
                  overflow: hidden;
              `}
`;

export const Arrow = styled(DropdownArrow)<{ isOpen: boolean }>`
    margin-left: 10px;
    ${({ isOpen }) => isOpen && 'transform: rotate(-180deg);'}
    ${Transition.arrow};
    min-width: 24px;
    min-height: 24px;

    ${Screen.ipad} {
        min-width: 24px;
        min-height: 24px;
    }
    ${Screen.desktop} {
        min-width: 35px;
        min-height: 34px;
    }
`;

export const StatusMsg = styled.div`
    color: ${cssVars.fg_gray1_white};
    ${Text.Full.normal.medium};
`;

export const Description = styled.div`
    font-style: italic;
    color: ${cssVars.fg_gray3_dark1};
    ${Text.Full.medium.medium};
    width: fit-content;
    text-align: center;
`;

export const PromoBottomWrapper = styled.div`
    display: flex;
    justify-content: space-around;
    padding: 23px 0 16px;
`;

export const BtnWrapper = styled(Button)`
    height: 36px;
    width: fit-content;
    max-width: 196px;
    ${Text.Full.medium.medium};

    ${Screen.desktop} {
        height: 45px;
        flex-grow: 0;
    }
`;

export const PromoInput = styled.input`
    ${FlexPresets.flexRowCenter};
    border: ${borders.small} ${cssVars.fg_gray3_dark1};
    border-radius: ${radius.large};
    background-color: ${cssVars.bg_white_dark3};
    ${Text.Full.medium.medium};
    padding: 0px 20px;
    margin: 0px 10px 0 0;
    height: 36px;
    width: 61%;
    color: ${cssVars.svg_gray2_gray3};

    ${Screen.desktop} {
        width: 403px;
        height: 45px;
    }
`;
